import React, {useState, useEffect} from "react";
import {
    Typography,
    Card,
    CardHeader,
    CardBody,
    IconButton,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem, Chip, DialogHeader, DialogBody, Button, DialogFooter, Dialog, Textarea, Input, Tooltip,
} from "@material-tailwind/react";
import {NumericFormat} from "react-number-format";
import {InformationCircleIcon} from "@heroicons/react/16/solid";
import axios from "axios";
import {MagnifyingGlassIcon} from "@heroicons/react/24/solid";
import {XMarkIcon} from "@heroicons/react/24/outline";

const Invoices = (props) => {
    const [invoices, setInvoices] = useState([]);
    const [openCancellationDialog, setOpenCancellationDialog] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [notes, setNotes] = useState(null);
    const [notesError, setNotesError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [openDialogPre, setOpenDialogPre] = useState(false);

    useEffect(() => {
        fetchInvoices();
    }, []);

    const fetchInvoices = async () => {
        fetch("/invoices.json")
            .then((response) => response.json())
            .then((data) => setInvoices(data))
            .catch((error) => console.error("Error fetching invoices:", error));
    }

    const cancellationDialog = (invoice) => {
        setSelectedInvoice(invoice);
        setOpenCancellationDialog(true);
    }

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    const handleSearch = async () => {
        setInvoices([]);
        fetch(`/invoices/search.json?search=${searchQuery}`)
            .then((response) => response.json())
            .then((data) => setInvoices(data))
            .catch((error) => console.error("Error fetching invoices:", error));
    }

    const resetSearch = () => {
        setSearchQuery('');
        fetchInvoices();
    }

    const handleCancellation = async () => {
        if (notes) {
            axios.defaults.headers.common["X-CSRF-Token"] = getCSRFToken();
            await axios.patch(`/invoices/${selectedInvoice.id}/cancel_invoice.json`, {
                notes: notes,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                window.location.href = '/invoices';
            }).catch(function (error) {
                setNotesError(error.data);
            });
        } else {
            setNotesError('Es necesario ingresar un motivo de cancelación.')
        }
    }

    const handleCancellationDialog = (value) => {
        setNotes(null);
        setNotesError(null);
        setSelectedInvoice(null);
        setOpenCancellationDialog(value);
    }


    return (
        <>
            <div className="mt-12">
                <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                    <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                        <CardHeader
                            floated={false}
                            shadow={false}
                            color="transparent"
                            className="m-0 flex items-center justify-between p-6"
                        >
                            <div className="w-full">
                                <Typography variant="h6" color="blue-gray" className="mb-1">
                                    Recibos
                                </Typography>
                                <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-end">
                                    {searchQuery &&
                                        <IconButton
                                            variant="text"
                                            className="rounded-full"
                                            onClick={resetSearch}
                                            title='Borrar filtro'
                                        >
                                            <XMarkIcon className='h-4 w-4'/>
                                        </IconButton>
                                    }
                                    <div className='w-full md:w-72'>
                                        <Input
                                            label="Buscar recibo"
                                            icon={<MagnifyingGlassIcon className="h-5 w-5"/>}
                                            onChange={(e) => setSearchQuery(e.target.value.toUpperCase())}
                                            className={'uppercase'}
                                            value={searchQuery}
                                        />
                                    </div>
                                    <Button className="w-full md:w-auto" onClick={handleSearch}>
                                        Buscar
                                    </Button>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="px-0 pt-0 pb-2">
                            <div className="overflow-x-auto">
                            <table className="w-full min-w-[640px] table-auto">
                                <thead>
                                <tr>
                                    {["Folio", "Fecha", "Clave", "Contribuyente", "Usuario", "Estado", "Total", "Acciones"].map(
                                        (el) => (
                                            <th
                                                key={el}
                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                            >
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    {el}
                                                </Typography>
                                            </th>
                                        )
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {invoices.length > 0 ? (
                                    invoices.map((invoice, key) => {
                                        const className = `py-3 px-5 ${
                                            key === invoices.length - 1 ? "" : "border-b border-blue-gray-50"
                                        }`;

                                        return (
                                            <tr key={invoice.id} className={`cursor-pointer hover:bg-gray-50`}>
                                                <td className={className}>
                                                    <div className="flex items-center gap-4">
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            {invoice.id}
                                                        </Typography>
                                                    </div>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {invoice.date}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {invoice.parcel_code}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {invoice.contributor_name}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {invoice.username}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    {invoice.status === 'CANCELADO' ?
                                                        (<Tooltip content={invoice.notes} placement={"left"}>
                                                            <Chip variant="ghost"
                                                                  color={'red'}
                                                                  size="sm"
                                                                  value={invoice.status}
                                                                  className='text-center text-[11px] w-max'
                                                            />
                                                        </Tooltip>)
                                                        : (invoice.payment_type === 'P' ? (
                                                            <Tooltip content={invoice.notes} placement={"left"}>
                                                                <Chip variant="ghost"
                                                                      color={'yellow'}
                                                                      size="sm"
                                                                      value={invoice.payment_type_name}
                                                                      className='text-center text-[11px] w-max'
                                                                />
                                                            </Tooltip>) : (<Chip variant="ghost"
                                                                                 color={'green'}
                                                                                 size="sm"
                                                                                 value={invoice.status}
                                                                                 className='text-center text-[11px] w-max'
                                                        />))
                                                    }

                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        <NumericFormat
                                                            value={invoice.total.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            allowLeadingZeros
                                                            thousandSeparator=","
                                                        />
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    {invoice.payment_type_name !== 'PRESCRIPCIÓN' &&
                                                        <Menu placement="left-start">
                                                            <MenuHandler>
                                                                <IconButton size="sm" variant="text" color="blue-gray">
                                                                    ...
                                                                </IconButton>

                                                            </MenuHandler>
                                                            <MenuList>
                                                                {invoice.status === 'PAGADO' &&
                                                                    <MenuItem
                                                                        onClick={() => cancellationDialog(invoice)}
                                                                        className='text-red-600 !hover:bg-red-300'
                                                                    >
                                                                        Cancelar Recibo
                                                                    </MenuItem>
                                                                }
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        window.open(`/print_ticket/${invoice.id}`, "_blank");
                                                                    }}
                                                                >
                                                                    Imprimir Recibo
                                                                </MenuItem>

                                                            </MenuList>
                                                        </Menu>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })) : (
                                    <tr>
                                        <td colSpan='8' className='text-center'>
                                            <div
                                                className="flex justify-center items-center text-gray-500 rounded-md py-4">
                                                No se encotraron registros.
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>

            {selectedInvoice ? (
                <>
                    <Dialog open={openCancellationDialog} handler={() => handleCancellationDialog(false)}>
                        <DialogHeader>Cancelar recibo {selectedInvoice.id}</DialogHeader>
                        <DialogBody
                            className="max-h-250 overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded-xl [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:rounded-xl [&::-webkit-scrollbar-track]:bg-slate-100">

                            <table className="w-full table-auto">
                                <thead>
                                <tr>
                                    {["Fecha", "Clave", "Contribuyente", "Usuario"].map(
                                        (el) => (
                                            <th
                                                key={el}
                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                            >
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    {el}
                                                </Typography>
                                            </th>
                                        )
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                <tr key={selectedInvoice.id} className={``}>
                                    <td className='py-3 px-5 border-b border-blue-gray-50 cursor-pointer hover:bg-gray-50'>
                                        <Typography
                                            variant="small"
                                            className="text-xs font-medium text-blue-gray-600"
                                        >
                                            {selectedInvoice.date}
                                        </Typography>
                                    </td>
                                    <td className='py-3 px-5 border-b border-blue-gray-50 cursor-pointer hover:bg-gray-50'>
                                        <Typography
                                            variant="small"
                                            className="text-xs font-medium text-blue-gray-600"
                                        >
                                            {selectedInvoice.parcel_code}
                                        </Typography>
                                    </td>
                                    <td className='py-3 px-5 border-b border-blue-gray-50 cursor-pointer hover:bg-gray-50'>
                                        <Typography
                                            variant="small"
                                            className="text-xs font-medium text-blue-gray-600"
                                        >
                                            {selectedInvoice.contributor_name}
                                        </Typography>
                                    </td>
                                    <td className='py-3 px-5 border-b border-blue-gray-50 cursor-pointer hover:bg-gray-50'>
                                        <Typography
                                            variant="small"
                                            className="text-xs font-medium text-blue-gray-600"
                                        >
                                            {selectedInvoice.username}
                                        </Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='3' className='text-right py-3 px-5'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Total
                                        </Typography>
                                    </td>
                                    <td className='py-3 px-5 border-l border-b border-blue-gray-50 cursor-pointer hover:bg-gray-50'>
                                        <Typography
                                            variant="small"
                                            className="text-xs font-medium text-blue-gray-600"
                                        >
                                            <NumericFormat
                                                value={selectedInvoice.total.toFixed(2)}
                                                displayType={'text'}
                                                prefix={'$'}
                                                allowLeadingZeros
                                                thousandSeparator=","
                                            />
                                        </Typography>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <Typography variant={"small"}
                                        className={`mt-4 pl-1 font-medium ${notesError && 'text-red-600'}`}>
                                Motivo
                            </Typography>
                            {notesError &&
                                <Typography color={"red"} variant={"small"} className='pl-1 font-medium'>
                                    {notesError}
                                </Typography>
                            }
                            <Textarea placeholder={'Agregue motivo de cancelación'}
                                      rows={6}
                                      className="mt-2 !border-blue-gray-200 focus:!border-0 focus:ring focus:ring-blue-500 focus:ring-inset"
                                      onChange={(e) => {
                                          setNotes(e.target.value)
                                      }}
                                      error={!!notesError}
                                      labelProps={{
                                          className: "!border-0 before:!border-0 after:!border-0",
                                      }}
                            />
                            <Typography
                                variant="small"
                                color="red"
                                className="mt-2 flex items-center gap-1 font-normal"
                            >
                                <InformationCircleIcon className='h-4 w-4'/>
                                Esta acción cancelará el recibo seleccionado y no es reversible.
                            </Typography>
                        </DialogBody>
                        <DialogFooter>
                            <Button
                                variant="text"
                                color="red"
                                onClick={() => handleCancellationDialog(false)}
                                className="mr-1"
                            >
                                <span>Cancelar</span>
                            </Button>
                            <Button variant="gradient" color="green" onClick={handleCancellation}>
                                <span>Confirmar</span>
                            </Button>
                        </DialogFooter>
                    </Dialog>
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default Invoices;
